import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { i18n, initializeLocale } from './i18n'
import './assets/scss/v2-tokens.css'

// Initialize the app with proper locale detection
async function initializeApp() {
  // Initialize locale based on user's location
  const initialLocale = await initializeLocale();
  
  // Create and mount the app
  const app = createApp(App);
  
  app.use(i18n)
    .use(store)
    .use(router)
    .mount("#app");
    
  // Redirect to appropriate language route if needed
  if (initialLocale === 'bg' && window.location.pathname === '/') {
    router.push('/bg');
  } else if (initialLocale === 'en' && window.location.pathname === '/') {
    router.push('/en');
  }
}

initializeApp();
